<template>
  <div class="light exchange-wallet-guest-layout">
    <div class="exchange-wallet-guest-layout__guests-heading">
      {{ i18n.t('exchange-form.drop-down.sign-in-title') }}
    </div>

    <div class="exchange-wallet-guest-layout__guests-heading-btns">
      <a class="button button--secondary button--small" :href="loginLink">{{ i18n.t('exchange-form.drop-down.log-in') }}</a>
      <a class="button button--primary button--small" :href="registerLink">{{ i18n.t('exchange-form.drop-down.sign-up') }}</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { i18n } from '@kano/i18n';
import { computed } from 'vue';
import UrlHelper from '@/helpers/UrlHelper';

const loginLink = computed(() => {
  return UrlHelper.toPaybisFrontUrl('login/', i18n.locale);
});

const registerLink = computed(() => {
  return UrlHelper.toPaybisFrontUrl('signup/', i18n.locale);
});
</script>

<style lang="scss" scoped>
.exchange-wallet-guest-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  max-width: 230px;
  margin: 0 auto;

  &__guests-heading {
    color: var(--color-base-48);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 16px;

    &-btns {
      display: flex;
      gap: 8px;
      justify-content: center;
    }
  }
}
</style>
